  <template>
  <div class="dashboard">
    <div class="container" v-if="project">

      <div v-if="isLoading" class="text-center">
        <hr class="space space-sm">
        <loader size="128px"></loader>
        <p class="small muted pt-4">One moment...</p>
      </div>

      <div v-else-if="error" class="text-center">
        <hr class="space space-sm">
        <p class="small error pt-4">{{ error }}</p>
      </div>

      <div class="text-center mb-4" v-else>
        <h1>{{ project.name }}</h1>
        <p class="light small lh15 muted">{{ project.tagline }}</p>
        <p class="medium mb-2 text-muted">
          <img :src="'/static/images/icons/project_status_' + project.status_icon + '.svg'" alt="">
          {{ project.status }}
        </p>
      </div>

      <ul class="nav nav-tabs nav-justified nav-clients small medium" v-if="project && !error">
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('overview')" :class="{ active: isActive('overview') }" href="#home">
            <img v-if="isActive('overview')" src="/static/images/icons/project_overview.svg" alt="">
            <img v-else src="/static/images/icons/project_overview_inactive.svg" alt="">
            <br>
            <span>Overview</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('documents')" :class="{ active: isActive('documents') }" href="#profile">
            <img v-if="isActive('documents')" src="/static/images/icons/project_docs.svg" alt="">
            <img v-else src="/static/images/icons/project_docs_inactive.svg" alt=""><br>
            <span>Docs</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('team')" :class="{ active: isActive('team') }" href="#profile">
            <img v-if="isActive('team')" src="/static/images/icons/project_team.svg" alt="">
            <img v-else src="/static/images/icons/project_team_inactive.svg" alt=""><br>
            <span>Team</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('invoices')" :class="{ active: isActive('invoices') }" href="#profile">
            <img v-if="isActive('invoices')" src="/static/images/icons/project_invoices.svg" alt="">
            <img v-else src="/static/images/icons/project_invoices_inactive.svg" alt=""><br>
            <span>Invoices</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="container" v-if="project && !error">
      <div class="tab-content py-3">
        <vue-page-transition name="fade">
          <router-view></router-view>
        </vue-page-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'project-base',
  props: ['id'],
  data () {
    return {
      activeItem: 'overview',
      isLoading: true,
      error: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      project: state => state.projects.current
    })
  },
  mounted () {
    this.$store.dispatch('LOAD_PROJECT_BY_ID', this.id)
      .then((response) => {
        this.isLoading = false
      })
      .catch((error) => {
        console.log(error)
        this.isLoading = false
        this.error = String(error)
      })
    window.scrollTo(0, 0)
    this.updateActive()
  },
  watch: {
    '$route' () {
      this.updateActive()
    }
  },
  methods: {
    updateActive () {
      let name = this.$router.currentRoute.name
      this.activeItem = name.replace('project-', '')
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
      this.$router.push({ 'name': 'project-' + menuItem, 'params': { id: this.id } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
